import { useFormContext } from "react-hook-form";
import { DropdownSelectOption, Loading } from "@/components/atoms";
import { useOperator } from "@/hooks";
import { useGetCountryStatesQuery } from "@/redux/apis/resource/resourceApi";
import { useEffect, useState } from "react";
import { EditExternalSupplierDetailsFormData } from "../form";
import { ExternalSupplierDetail } from "../../../common/ExternalSupplierDetail";

interface StateFieldProps {
  state: string;
  editMode: boolean;
}

export const StateField = ({ state, editMode }: StateFieldProps) => {
  const {
    setValue,
    watch,
  } = useFormContext<EditExternalSupplierDetailsFormData>();
  const { country: defaultCountry } = useOperator();
  const { isFetching, data } = useGetCountryStatesQuery(defaultCountry);
  const [options, setOptions] = useState<Array<DropdownSelectOption>>([]);
  const stateValue = watch("state");

  useEffect(() => {
    if (data) {
      const { states } = data.data;
      setOptions(states.map(state => ({ name: state.name, value: state.id })));
      setValue("state", states.find(stateItem => stateItem.abbreviation === state)?.id || "");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <div className="relative">
      {isFetching && <Loading />}
      <ExternalSupplierDetail
        editMode={editMode}
        label="State"
        detail={
          // editMode ? (
          //   <div className="flex flex-col gap-1">
          //     <Controller
          //       name="state"
          //       control={control}
          //       render={({ field }) => (
          //         <DropdownSelect
          //           className="w-full"
          //           options={options}
          //           placeholder="Select State"
          //           value={field.value?.toString()}
          //           onChange={(value) => field.onChange(value)}
          //           hasError={!!errors.state}
          //         />
          //       )}
          //     />
          //     <ErrorMessage errors={errors} name="state" />
          //   </div>
          // ) : options.find(option => option.value === stateValue)?.name
          options.find(option => option.value === stateValue)?.name
        }
      /> 
    </div>
  );
};
